enum ResourcesVisibility {
  ALL = "organization", // All org users
  TEAM = "teams", // Within Team only
  NONE = "user",
}

export default ResourcesVisibility;
